const datas = [
  {
    name: 'data',
    title: 'Chess Updates',
    description:
      'Spell Chess Opening Theory',
    intro: 'Read Documentation →',
    img: 'https://mesinkasironline.web.app/img/createwebsiteusingreact.png',
  },
];

export const articles = [
  {
    name: 'about',
    title: 'Spell Chess Opening Theory',
    date: '28 Feb 2023',
    desc: 'about cute blog for react js',
    author: 'Pureshwar',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://cdn.dribbble.com/users/77598/screenshots/5919494/dribbble.png',
    content: [
      `In the last post, I recommended Black respond to 1.e4 with 1.Nc6. I now think 1.Nc6 doesn't work at all. By far the two most important first moves in chess are 1. e4 and 1. d4. With these moves, White occupies as much of the center as possible (a key component in opening principles).`,
    ],
  },
  {
    name: 'IQ',
    title: 'IQ of Magnus Carlsen',
    desc: 'Magnus Carlsen',
    date: '20 October 2023',
    author: 'Magnus Carlsen',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://media.istockphoto.com/vectors/business-communication-internet-blogging-post-flat-design-vector-vector-id1143088863?k=20&m=1143088863&s=612x612&w=0&h=kJgOoz9QAhbT83Acyhm9whRtxt2j7J7VzWAxCHuEa8o=',
    content: [
      `How big is Magnus Carlsen IQ?
I wouldn't want to know it anyway. It might turn out to be a nasty surprise.” A few experts estimated Magnus Calsen's IQ to be around 190. Regardless of his IQ, it is no doubt that he is a chess wizard. GM Vladimir Kramnik called Magnus Carlsen a “close to genius” during the 2014 World Championship.`,
    ],
  },
  {
    name: 'installation',
    title: 'What should an intermediate chess player learn?',
    date: '20 april 2023',
    author: 'Hikaru Nakamura',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://thumbs.dreamstime.com/b/flat-design-business-process-workflow-management-communicating-ready-to-animation-characters-compouse-your-scenes-office-work-128992317.jpg',
    desc: 'IQ of Magnus Carlsen',
    content: [
      `Space is dictated by pawn play in many ways, and "your space" is essentially all the squares you control behind your most advanced pawns (or pawns within the enemy's territory). Learning to correctly use space and "build strength" in your position is critical`,
    ],
  },
  {
    name: 'work',
    title: 'Work',
    date: '20 april 2022',
    author: 'Magnus Carlsen',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://img.freepik.com/free-vector/happy-freelancer-with-computer-home-young-man-sitting-armchair-using-laptop-chatting-online-smiling-vector-illustration-distance-work-online-learning-freelance_74855-8401.jpg?w=2000',
    desc: 'How to work with cuteblog react',
    content: [
      `Oke after you have successfully installed and run on your devices, now you can open source code project using visual code studio, then you can open on src folder , and select ArticleContent.js files - open and edit this files then change with you needed, just follow stucture files for create new article content, and save it for update data.`,
      `For SEO you can visit on index.js file and change title description and other on helmet .`,
    ],
  },
  {
    name: 'deploy',
    title: 'Deploy',
    date: '19 april 2022',
    author: 'Magnus Carlsen',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://img.freepik.com/free-vector/people-putting-puzzle-pieces-together_52683-28610.jpg?w=2000',
    desc: 'How to deploy on static hosting or shared cloud hosting',
    content: [
      `Oke after change and finishin your project , now you need to cloud your source code right, this is for online your website and blog, so for first you can use two option using firebase and surge or use netlify , vercel, heroku etc.`,
      `For using firebase and surge for first you need to build to production mode, so you can input this command on shell terminal npm run build - then you can deploy on public folder to firebase or surge .`,
      `Option two you can use github intergation with heroku,vercel,netlify - just create account and create new repo and push your source code to your repo project, and you need to integration with netlify ,heroku or vercel, just create new project then select your github repo and deploy it. `,
    ],
  },
  {
    name: 'alternative',
    title: 'Alternative',
    date: '18 april 2022',
    author: 'Magnus Carlsen',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://appedology.pk/wp-content/uploads/2020/11/6be369b11b50e0b1c3a2fea19ba7e2ba.png',
    desc: 'Use static site generator with cuteblog',
    content: [
      `If you need to build and develope cuteblog project with static site generator , of course you can do it... we have develope cuteblog for jekyll, eleventy 11ty and astro, just visit on our github repo and search cuteblog with generator static site download it then run and deploy on hosting.`,
      `You can visit on our blog for download all source code project, just visit on https://www.hockeycomputindo.com/2010/12/blog-post.html`,
      `Cuteblog for jekyll`,
      `https://www.hockeycomputindo.com/2022/04/auto-seo-dengan-cuteblog-for-jekyll.html`,
      `Cuteblog for eleventy`,
      `https://www.hockeycomputindo.com/2022/04/cuteblog-11ty-for-eleventy-generator.html`,
      `Cuteblog for astro`,
      `https://www.hockeycomputindo.com/2022/04/cute-blog-astro-generator-static-site.html`,
      `Cuteblog for pico cms`,
      `https://www.hockeycomputindo.com/2022/04/tema-blog-website-terbaru-dan-gratis.html`,
    ],
  },
  {
    name: 'cms',
    title: 'Cuteblog CMS',
    date: '18 april 2022',
    author: 'Magnus Carlsen',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://img.freepik.com/free-vector/group-people-working-together_52683-28615.jpg?w=2000',
    desc: 'If you need build cuteblog with backend admin area so use cuteblog webapp',
    content: [
      `And if you need to work with admin area of course you can do it, yeah.. we have develope cuteblog for content management system to.. so with this cms you can easy for install and deploy or run on your shared cloud hosting, yes.. we have develope using php lang, so you can easy for deploy on your cloud shared hosting.`,
      `Cuteblog pico cms, yes.. we have develope using pico cms, so why use pico ?? of course with pico is very secure and fast , this way why we chose pico, just download and upload it on your hosting then your webiste is live, and you can work with admin area too.. so if you need work using pico cms so download now just visit this link https://Magnus Carlsen.my.id/pico/cuteblog .`,
      `Cuteblog for Get Magnus Carlsen cms - on progress development... yes this is our cms project from get simple, so you can easy download it and upload on hosting, then you can work with admin area and text editor is include , no need database installation, so you can download cuteblog for get Magnus Carlsen on https://Magnus Carlsen.com/getMagnus Carlsencms`,
    ],
  },
  {
    name: 'cloud',
    title: 'Cloud with Us',
    date: '16 april 2022',
    author: 'Magnus Carlsen',
    authorlink: 'https://www.linkedin.com/in/pureshwar-gonekar-358b661aa/',
    img: 'https://media.istockphoto.com/vectors/multimedia-content-upload-interface-vector-id1299267805?k=20&m=1299267805&s=612x612&w=0&h=h2TKY77Vcd2144vvjYZbn2eTQr6XoHxDLPMKvI4jU7Q=',
    desc: 'Create and build your modern website with us for best solutions',
    content: [
      `If you need to build and develop modern website using modern technology like static site generator with jekyll, eleventy 11ty , astro or user react, svelte kit, angular so you can use our services with cheap price`,
      `Or you need to create web app where website integration with your point of sale application so we can do it , with multiple technology let's get started build your website application including android app.`,
      `Contact Us`,
      `Whatsapp : +123456789`,
      `Call Us : +00001110001`,
      `Email : magnuscarlsen@gmail.com`,
    ],
  },
];

export default datas;